module.exports = __webpack_public_path__ + "fad2b5ad209d712c51adfea085fd1dfb.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-group-link/sp-group-link.html
// module id = 1106
// module chunks = 0